import React, { useContext, useState } from "react"
import { Alert, Box, ModalClose } from "@mui/joy"
import { useTranslation } from 'react-i18next'
import { BreadCrumb, Button, DetailTitle, InfoHeader, Text } from "src/mtska-frontend-app-component"
import { Importer, Importer2, ImporterFileMappingConstants } from "../components"
import { AppContext } from "src/mtska-frontend-app-scaffolding"

const Create = (params) => {
    const { t } = useTranslation();
    const { appConfiguration } = useContext(AppContext);
    const [version, setVersion] = useState(appConfiguration.importer.version ?? null);
    const [actionInvoked, setActionInvoked] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [forwardDisabled, setForwardDisabled] = useState(false);
    const [backDisabled, setBackDisabled] = useState(true);
    const [actionLabel, setActionLabel] = useState(t("Next"));

    return <>
        {params.isDrawer && (
            <Box className="drawer-section-header">
                <ModalClose />

                {version === 'ImporterFileMappingConstants' ? (
                    <>
                        <DetailTitle title={t('Import')} icon="faFile" />

                        <Box display="flex" flexDirection="row" justifyContent="end" gap={1} flexGrow={1}>
                            <Button
                                label={'Back'}
                                onClick={() => setActionInvoked(-1)}
                                disabled={backDisabled}
                            />
                            <Button
                                label={actionLabel}
                                onClick={() => setActionInvoked(1)}
                                disabled={forwardDisabled}
                            />
                        </Box>
                    </>

                ) : (
                    <Text level="title-md" icon>
                        {t("New Import")}
                    </Text>
                )}
            </Box>
        )}

        {params.isDrawer && version === 'ImporterFileMappingConstants' && <BreadCrumb />}
        {
            version === 1 && <Importer {...params} />
        }
        {
            version === 2 && <Importer2 {...params} />
        }
        {
            version === 'ImporterFileMappingConstants' && (
                <>
                    {errorMessage && (
                        <Alert color="danger">{errorMessage}</Alert>
                    )}
                    <Box className="drawer-section-content">
                        <InfoHeader
                            view="wizard"
                            title={t('Import file')}
                            subtitle={t('Upload a file to the system')}
                        />
                        <ImporterFileMappingConstants
                            {...params}
                            externalSetForwardDisabled={setForwardDisabled}
                            externalSetBackDisabled={setBackDisabled}
                            externalSetActionInvoked={setActionInvoked}
                            externalSetActionLabel={setActionLabel}
                            externalSetErrorMessage={setErrorMessage}
                            actionInvoked={actionInvoked}
                        />
                    </Box>
                </>
            )
        }
    </>

}

export default Create;


